import React, { useEffect, useState } from "react";
import {
  ChangeTitle,
  decrypt,
  formatPrice,
  selectStyle3,
  toAbsoluteUrl,
  toasterrormsg,
} from "../../helpers/Reusable";
import { apiHeader, getData, postData } from "../../helpers/ApiHelper";
import { BiMinus } from "react-icons/bi";
import { BsPlusLg } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import Slider from "react-slick";
import { ToastContainer } from "react-toastify";
import { getCookie, setCookie } from "../../helpers/CookieComponent";
import { FaBook, FaFileAlt, FaGlobeAmericas, FaTag } from "react-icons/fa";

const PracticeArticle = () => {
  ChangeTitle("Practice Articles");
  const [openIndex, setOpenIndex] = useState(null);

  const [selectedCurrency, setSelectedCurrency] = useState("INR");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [currencySymbol, setCurrencySymbol] = useState("₹");
  const [currencyList, setCurrencyList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [filterPlanList, setFilterPlanList] = useState([]);
  const [faqsList, setFaqsList] = useState([]);
  const navigate = useNavigate();
  const auth = decrypt(getCookie("token")) || "";

  const isOpen = (index) => openIndex === index;

  // Toggle accordion
  const toggleAccordion = (index) => {
    setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  // Currency API Call
  const viewCurrencyList = async () => {
    const param = {};
    var response = await postData("currency/list", param, apiHeader(false));

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const currencyData = data.map((data) => {
        return {
          id: data._id,
          value: data.countryDetail.currency,
          label: `${data.countryDetail.currencyName} (${data.countryDetail.currencySymbol}) - ${data.countryDetail.currency}`,
          currencySymbol: data.countryDetail.currencySymbol,
          currency: data.countryDetail.currency,
        };
      });
      setCurrencyList(currencyData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Country API Call
  const viewCountryList = async () => {
    const param = {};
    var response = await postData(
      "country/list",
      param,
      apiHeader(false),
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const listData = data.map((data) => {
        return {
          value: data._id,
          label: data.countryName,
        };
      });
      setCountryList(listData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Faqs API Call
  const viewFaqsList = async () => {
    const param = {
      type: "practice",
    };
    var response = await postData("faq/list", param, apiHeader(false));

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const faqsData = data.map((data) => {
        return {
          id: data._id,
          question: data.question,
          answer: data.answer,
        };
      });
      setFaqsList(faqsData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Plans API Call
  const viewFilterPlanList = async (currency, countryId = "") => {
    const param = {
      currency: String(currency),
    };
    if (countryId) {
      param.countryId = String(countryId);
    }

    var response = await postData(
      "practiseplan/user/list",
      param,
      apiHeader(false),
    );
    console.log(response, "response");

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data.list;
      const filterPlanListData = data.map((item) => {
        return {
          id: item._id,
          price: formatPrice(item.price, selectedCurrency),
          currency: item.defaultCurrency,
          name: item.name,
          createdDate: item.createdDate,
          categories:
            item.practisecategoryDetail?.map((cat) => ({
              id: cat._id,
              name: cat.name?.trim() || "",
            })) || [],
          chapters:
            item.practiseChapterDetail?.map((ch) => ({
              id: ch._id,
              name: ch.chapterName?.trim() || "",
            })) || [],
          articles:
            item.practiseArticleDetail?.map((ar) => ({
              id: ar._id,
              name: ar.articleName?.trim() || "",
            })) || [],
          countries:
            item.countryDetail?.map((c) => ({
              id: c._id,
              name: c.countryName?.trim() || "",
              currency: c.currency || "",
            })) || [],
          duration: item.duration,
          durationType: item.durationType,
        };
      });

      setFilterPlanList(filterPlanListData);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Plan Buy Function
  const buyPlan = async (data) => {
    setCookie("practice-planbillingId", data.id, {});
    setCookie("practice-plan-duration", data.duration, {});
    setCookie("practice-plan-durationType", data.durationType, {});
    const param = {
      planId: data.id,
      currency: data.currency || "INR",
    };
    var response = await postData(
      "private/practiseplanpurchase/preview",
      param,
      apiHeader(false),
    );
    console.log("practice plan detail billing", response);
    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      navigate("/practice/billing");
    } else {
      toasterrormsg(response.data.message);
    }
  };

  useEffect(() => {
    viewCountryList();
    viewFaqsList();
    viewCurrencyList();
    viewFilterPlanList("INR", "");
    setCookie("practice-plan-currency", "INR", {});
  }, []);

  useEffect(() => {
    viewFilterPlanList(selectedCurrency, selectedCountry);
  }, [selectedCurrency, selectedCountry]);

  // Slider Settings - dynamic slidesToShow based on filterPlanList length
  const getSlidesToShow = () => {
    const length = filterPlanList.length;
    if (length > 4) return 4;
    if (length < 3) return length || 1;
    return length;
  };

  const dynamicSlidesToShow = getSlidesToShow();

  const rrSetting2 = {
    slidesPerRow: 1,
    slidesToShow: dynamicSlidesToShow,
    slidesToScroll: 1,
    infinite: false,
    swipeToSlide: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: Math.min(dynamicSlidesToShow, 4),
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 976,
        settings: {
          slidesToShow: Math.min(dynamicSlidesToShow, 2),
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  // Practice Features Data
  const practiceFeatures = [
    {
      title: "Know the precise and complete law in minutes!",
      description:
        "Understand the complete law in minutes with simple language, updated authentic content, and ready-made summaries, tables, and infographics.",
    },
    {
      title: "Prepare extraordinary opinions and replies",
      description:
        "Get expert-prepared, well-researched practical guidance with downloadable specimen formats.",
    },
    {
      title: "Solution for multidimensional transactions (360° Coverage)",
      description:
        "360° guidance covering implications under multiple laws—Corporate Tax, VAT, Excise, Stamp Duty, and business setup regulations.",
    },
    {
      title: "Powerful search engine for instant answers",
      description: "Fast, customized search with AI-powered exact answers.",
    },
    {
      title: "Integrated and embedded content",
      description:
        "Hyperlinked content with change annotations and smart related-document recommendations.",
    },
    {
      title: "Learn compliances under various laws",
      description:
        "Step-by-step guides with real portal screenshots and live updates.",
    },
  ];

  return (
    <>
      <ToastContainer />

      {/* Practice Features Section */}
      <div className="relative w-full h-auto px-[5%] py-[5%]  lg:py-[2%] bg-light-yellow">
        <div className="xxl:container mx-auto">
          <div className="mb-[3rem]">
            <h1 className="mb-[1rem] rrd-title">
              Practice is a comprehensive platform for GCC tax law practice.
              Here's a simple breakdown of its features:
            </h1>
            <ul className="pl-[3rem] lg:pl-[5rem] rrd-ul">
              {practiceFeatures.map((feature, index) => (
                <li key={index} className="rrd-ul-li">
                  {feature.title} -{" "}
                  <span className="rrd-ul-li-span">{feature.description}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Currency and Country Selection */}
          <div className="w-[90%] mx-auto grid grid-cols-1 md:grid-cols-2 md:gap-20 mb-[3rem]">
            <div className="flex relative z-[3] mb-[2rem] justify-center items-center gap-5">
              <label className="w-max currencylabel">Currency</label>
              <div className="w-[80%] currencyselect">
                <Select
                  name="currenyName"
                  id="currencyName"
                  placeholder="Select Currency"
                  className="w-full cs-main"
                  isSearchable={true}
                  options={currencyList}
                  value={currencyList.find(
                    (item) => item.value === selectedCurrency,
                  )}
                  onChange={(e) => {
                    setSelectedCurrency(e.value);
                    setCurrencySymbol(e.currency);
                    setCookie("practice-plan-currency", e.currency, {});
                  }}
                  styles={{
                    ...selectStyle3,
                    menuPortal: (base) => ({ ...base, zIndex: 99 }),
                  }}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                />
              </div>
            </div>
            <div className="flex relative z-[3] mb-[2rem] justify-center items-center gap-5">
              <label className="w-max currencylabel">Country</label>
              <div className="w-[80%] currencyselect">
                <Select
                  name="countryName"
                  id="countryName"
                  placeholder="Select Country"
                  className="w-full cs-main"
                  isSearchable={true}
                  options={countryList}
                  value={countryList.find(
                    (item) => item.value === selectedCountry,
                  )}
                  onChange={(e) => {
                    setSelectedCountry(e.value);
                  }}
                  styles={{
                    ...selectStyle3,
                    menuPortal: (base) => ({ ...base, zIndex: 99 }),
                  }}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                />
              </div>
            </div>
          </div>

          {/* Plans Section */}
          <div className="relative mb-[5%] w-[90%] flex mx-auto px-[3%] pb-[5%] pt-[1%] rr-combo-box rr-individual-box">
            <div className="w-full">
              {filterPlanList.length > 0 && (
                <Slider
                  className="w-full mx-auto cursor-pointer relative z-[1] hp1-part2-imgs rr-box"
                  {...rrSetting2}
                >
                  {filterPlanList.map((data) => (
                    <section key={data.id} className="px-2 h-full ">
                      <section
                        className="flex flex-col justify-between px-[5%] md:px-[10%] rrcb-main rrcwb-main h-full mb-5"
                        style={{ minHeight: "320px", height: "auto" }}
                      >
                        <section>
                         

                          {/* Plan Name */}
                          <h1  
                            className="w-full text-center py-[2%] hanson  text-[#2c3451]"
                            style={{ borderBottom: "2px solid #3a4553" }}
                          >
                            {data.name}
                          </h1>

                          {/* Features List */}
                          <div className="px-4 mb-4 pt-5">
                            <h2 className="text-center py-[5%]  rrcbprice">
                              {selectedCurrency} {data.price}
                            </h2>
                            {(data.duration !== undefined && data.duration !== null && data.duration !== "") && (
                              <h3 className="text-center mb-[5%] rrcbduration" style={{fontSize: "1.5rem", fontWeight: "700", color: "var(--primary-yellow)"}}>
                                Duration: {data.duration} {data.durationType || ""}
                              </h3>
                            )}

                            <ul className="space-y-3">
                              {/* Categories */}
                              {data.categories?.length > 0 && (
                                <li className="flex items-start gap-3">
                                  <FaTag size={22} className="flex-shrink-0 mt-1" />
                                  <span className="text-[18px] font-semibold text-gray-700">
                                    {data.categories.map((cat) => cat.name).join(", ")}
                                  </span>
                                </li>
                              )}

                              
                            </ul>
                          </div>
                        </section>

                        <section className="py-[1%] w-full btn-choose-plan">
                          <button
                            onClick={() => {
                              if (!auth) {
                                toasterrormsg("Please login first");
                                return false;
                              }
                              buyPlan(data);
                            }}
                            className="py-[1%] w-full btn-choose-plan"
                          >
                            Choose Plan
                          </button>
                        </section>
                      </section>
                    </section>
                  ))}
                </Slider>
              )}
              {filterPlanList.length == 0 && (
                <h1 className="text-center not-exist-msg">No data found</h1>
              )}
            </div>
          </div>

          {/* FAQ Section */}
          <div className="w-full faqs">
            <div className="w-full">
              <h1 className="hanson text-center mb-[1%] ap6-h1">FAQ's</h1>
              <img
                className="mb-[2%] mx-auto"
                src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
                alt=""
              />
            </div>
            <div className="w-full md:w-[90%] mx-auto flex flex-col gap-5 mb-[5%] faqs">
              {faqsList.map((data, index) => (
                <div
                  key={index}
                  className={
                    isOpen(index) ? "p-[2%] faqs-box-active" : "p-[2%] faqs-box"
                  }
                >
                  <button
                    onClick={() => toggleAccordion(index)}
                    className="flex w-full !text-start justify-between"
                  >
                    <span>{data.question}</span>
                    {isOpen(index) ? (
                      <BiMinus className="faqs-minus" />
                    ) : (
                      <BsPlusLg className="faqs-plus" />
                    )}
                  </button>
                  {isOpen(index) && (
                    <div className="px-4 pb-2 pt-4 text-sm text-gray-500">
                      <p
                        className=""
                        dangerouslySetInnerHTML={{ __html: data.answer }}
                      />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PracticeArticle;
